import React from 'react';
import { Alert } from '@hangar/web-components/core/Alert';
import * as S from './FlightChangesCases.styles';

interface ErrorSnackbarProps {
    open: boolean;
    onClose: () => void;
    children: React.ReactNode;
}

/** Fixed snackbar-style error surface — Hangar `Alert`; policy in `ECADCA-530-review.md` §2. */
export const ErrorSnackbar: React.FC<ErrorSnackbarProps> = ({ open, onClose, children }) => {
    if (!open) {
        return null;
    }

    return (
        <S.SnackbarFixedAnchor>
            <Alert
                id="flight-changes-error-snackbar"
                severity="error"
                width="fixed"
                showCloseButton
                onClose={onClose}
            >
                {children}
            </Alert>
        </S.SnackbarFixedAnchor>
    );
};
